export default function capterraTracking() {
  const capterra_vkey = '8a1d10b8c3938f1d6ff1d09003740d93';
  const capterra_vid = '2136899';
  const capterra_prefix = (('https:' == document.location.protocol)
    ? 'https://ct.capterra.com' : 'http://ct.capterra.com');
  const ct = document.createElement('script');
  ct.type = 'text/javascript';
  ct.async = true;
  ct.src = capterra_prefix + '/capterra_tracker.js?vid='
    + capterra_vid + '&vkey=' + capterra_vkey;
  const s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(ct, s);
};